import { render, staticRenderFns } from "./ZCard.vue?vue&type=template&id=5354578f&scoped=true&"
import script from "./ZCard.vue?vue&type=script&lang=js&"
export * from "./ZCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5354578f",
  null
  
)

export default component.exports